export type StringDistanceTypes = "None" | "Default" | "Levenshtein" | "JaroWinkler" | "NGram";
